import { Box, Grid, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Skeleton from '@mui/material/Skeleton';
import React from 'react';

import { Header } from './header';

const useStyles = makeStyles((theme: any) => ({
  padding: {
    padding: theme.spacing(3),
    gap: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
  calculatorContainer: {
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down('lg')]: {
      paddingLeft: 0,
      marginTop: theme.spacing(2),
    },
  },
}));

export const SkeletonPolicy = () => {
  const classes = useStyles();

  return (
    <Grid container>
      <Grid item xs={12} lg={8}>
        <Paper>
          <Grid container direction="column">
            <Header />
          </Grid>
          <Box className={classes.padding}>
            <Skeleton variant="rectangular" width="100%" height={50} />
            <Skeleton variant="rectangular" width="40%" height={30} />
            <Skeleton variant="rectangular" width="70%" height={30} />
            <Skeleton variant="rectangular" width="70%" height={30} />
            <Skeleton variant="rectangular" width="70%" height={30} />
            <Skeleton variant="text" />
            <Skeleton variant="rectangular" width="100%" height={400} />
          </Box>
        </Paper>
      </Grid>
      <Grid item xs={12} lg={4} className={classes.calculatorContainer}>
        <Paper className={classes.padding}>
          <Box className={classes.padding}>
            <Skeleton variant="rectangular" width="100%" height={50} />
            <Skeleton variant="text" />
            <Skeleton variant="rectangular" width="100%" height={90} />
            <Skeleton variant="rectangular" width="100%" height={50} />
            <Skeleton variant="text" />
            <Skeleton variant="rectangular" width="100%" height={90} />
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};
